import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

export const ViewEditDialogContainer = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "view-dialog-container",
})`
  padding-top: 16px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
